import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Dimensions, Image, Platform, ScrollView, StyleSheet, TouchableOpacity, View } from 'react-native';
import { Typography } from '../../typography/Typography';
import { ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StepperTypeTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import { ModalAlignmentEnum } from '@voltmoney/types';
import { addCommasToNumber } from "../utils";
import { Icon } from "../../icon/Icon";
import BottomSheet from "../BottomSheet";
import { isMobile } from "../../stack/utils";
import { getScreenType } from "../bankSelectPage/BankSelect";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { Stepper } from "../../stepper/Stepper";
import CustomHeader from "../../customHeader/CustomHeader";
/* fonts */
const FontFamily = {
    mobileHeadingH4Semibold: 'Poppins-SemiBold',
    mobileBodyNormalB1Semibold: 'Inter-SemiBold',
    interRegular: 'Inter-Regular',
    mobileBodyNormalB1Medium: 'Inter-Medium',
    mobileBodyNormalB0Bold: 'Inter-Bold',
};
/* font sizes */
const FontSize = {
    mobileHeadingH4Semibold_size: 16,
    mobileBodyNormalB1Semibold_size: 14,
    mobileBodyNormalB3Semibold_size: 10,
};
/* Colors */
const Color = {
    primary05: '#f3f5fc',
    primary100: '#1434cb',
    greyNight: '#1d2939',
    greyWhite: '#fff',
    colorWhitesmoke: '#f1f3f5',
    greyCharcoal: '#667085',
};
/* Paddings */
const Padding = {
    p_base: 16,
};
/* border radiuses */
const Border = {
    br_xs: 12,
    br_7xs_5: 6,
};
const KycCard = ({ viewAction, triggerAction, creditLimit, remainingSteps, showEditLimit, height, stepperData, bottomCTAAction, goBack, needHelp, continueEditAction, loading, isEnhancedLimit, isFromJupiterPlatform }) => {
    const [successLottie, setSuccessLottie] = useState("");
    const [onEditLimitPressed, setOnEditLimitPressed] = useState(false);
    useEffect(() => {
        fetch("https://lottie.host/ba694c30-17e4-4f1c-a650-e611690c4b26/svMY0M5rET.json", {
            method: "GET",
        })
            .then((response) => response.json())
            .then((responseData) => {
            console.log(responseData);
            setSuccessLottie(responseData);
        })
            .catch((error) => {
            console.log(error);
        });
    }, []);
    const renderEditLimitConfirmationBox = () => {
        return (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 272, width: '100%', alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width)) ? Platform.OS !== "ios" ? Dimensions.get('window').height + 10 : Dimensions.get('window').height : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: true, closeFunction: () => {
                    setOnEditLimitPressed(false);
                } },
                React.createElement(View, { style: {
                        justifyContent: 'center',
                        padding: 16,
                        paddingTop: 24,
                        alignContent: 'center',
                        alignItems: 'center'
                    } },
                    React.createElement(Icon, { name: IconTokens.SystemWarning, size: IconSizeTokens.XXXXXXL }),
                    React.createElement(View, { style: { marginTop: 24, marginBottom: 24 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: Platform.OS !== "web" ? "Are you sure you want to edit your limit?\nThis will reset your selected limit" : "Are you sure you want to edit your limit? This will reset your selected limit", textAlign: TextAlignTokens.center })),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.PRIMARY, label: "Yes, continue to edit limit", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            triggerAction({
                                ...continueEditAction
                            });
                        }, loading: loading }),
                    React.createElement(Space, { size: SizeTypeTokens.LG }),
                    React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: "No, continue with selected limit", width: ButtonWidthTypeToken.FULL, onPress: () => {
                            setOnEditLimitPressed(false);
                        } })))));
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { goBackAction: goBack, needHelpAction: needHelp, goBackId: 'btn_BajajKFS_goBack', needHelpId: 'btn_BajajKFS_needHelp', triggerAction: triggerAction, hideNeedHelp: false, hideGoBack: isFromJupiterPlatform }));
    }, []);
    return (React.createElement(View, { style: { height: Platform.OS === "ios" ? height - 12 : height, marginHorizontal: -16 } },
        React.createElement(View, { style: styles.headerStyle }, _headerChild),
        React.createElement(ScrollView, { style: { height: height - 44, paddingBottom: 80 } },
            React.createElement(View, { style: styles.frameParent },
                React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.MD, fontWeight: '700', lineHeight: 24, label: remainingSteps > 1 ? `Only ${remainingSteps} steps remaining!` : `Only ${remainingSteps} step remaining!` }),
                React.createElement(View, { style: styles.insideContainer },
                    React.createElement(View, { style: { flexDirection: "row" } },
                        React.createElement(Image, { source: {
                                uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/pledge_icon.png'
                            }, style: { width: 52, height: 52 } }),
                        React.createElement(View, { style: { marginLeft: 12 } },
                            React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.SM, fontWeight: '400', lineHeight: 20, color: ColorTokens.Grey_Charcoal, label: isEnhancedLimit ? "Eligible credit limit" : "Credit limit" }),
                            React.createElement(View, { style: { flexDirection: "row", alignContent: 'center', alignItems: 'center' } },
                                React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XXL, fontWeight: '700', lineHeight: 32, label: `₹` }),
                                React.createElement(Typography, { fontFamily: FontFamilyTokens.Poppins, color: ColorTokens.Grey_Night, fontSize: FontSizeTokens.XXL, fontWeight: '700', lineHeight: 32, label: `${addCommasToNumber(Math.floor(creditLimit))}` }),
                                showEditLimit && React.createElement(TouchableOpacity, { style: { marginLeft: 4 }, onPress: () => {
                                        setOnEditLimitPressed(true);
                                    } },
                                    React.createElement(Icon, { name: IconTokens.Edit, size: IconSizeTokens.XXL })))))),
                React.createElement(View, { style: { marginBottom: 12 } })),
            React.createElement(Space, { size: SizeTypeTokens.XXXL }),
            React.createElement(View, { style: { paddingHorizontal: 16 } },
                React.createElement(Stepper, { type: StepperTypeTokens.VERTICAL, data: stepperData }))),
        React.createElement(View, { style: styles.bottomContainer },
            React.createElement(Button, { loading: loading, id: "bt_kycStepper_continue", type: ButtonTypeTokens.LargeFilled, label: "Start", fontSize: FontSizeTokens.SM, width: ButtonWidthTypeToken.FULL, onPress: () => {
                    if (bottomCTAAction) {
                        triggerAction({
                            ...bottomCTAAction
                        });
                    }
                } })),
        onEditLimitPressed && renderEditLimitConfirmationBox()));
};
const styles = StyleSheet.create({
    frameGroupFlexBox: {
        alignItems: 'center',
        alignSelf: 'stretch',
    },
    frameSpaceBlock: {
        marginTop: 16,
        overflow: 'hidden',
        alignSelf: 'stretch',
    },
    groupPosition: {
        left: 0,
        position: 'absolute',
        flexDirection: 'row',
    },
    weWillApproveTypo: {
        color: Color.greyCharcoal,
        fontFamily: FontFamily.mobileBodyNormalB1Medium,
        fontWeight: '500',
        lineHeight: 20,
        fontSize: FontSize.mobileBodyNormalB1Semibold_size,
        marginLeft: 12,
        textAlign: 'left',
        flex: 1,
    },
    frameChild: {
        borderRadius: 6,
        width: 48,
        height: 48,
        overflow: 'hidden',
    },
    yourLoanForeclosure: {
        fontSize: FontSize.mobileHeadingH4Semibold_size,
        lineHeight: 24,
        fontWeight: '700',
        fontFamily: FontFamily.mobileBodyNormalB0Bold,
        marginLeft: 12,
        textAlign: 'left',
        color: Color.greyNight,
        flex: 1,
    },
    frameGroup: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    frameWrapper: {
        justifyContent: 'center',
        alignSelf: 'stretch',
    },
    frameItem: {
        maxWidth: '100%',
        height: 1,
        width: '100%',
    },
    nextSteps: {
        fontWeight: '600',
        fontFamily: FontFamily.mobileBodyNormalB1Semibold,
        lineHeight: 20,
        fontSize: FontSize.mobileBodyNormalB1Semibold_size,
        textAlign: 'left',
        color: Color.greyNight,
        alignSelf: 'stretch',
    },
    nextStepsWrapper: {
        justifyContent: 'center',
    },
    groupChild: {
        top: 11,
        left: 11,
        width: 1,
        height: 49,
        position: 'absolute',
    },
    frameInner: {
        width: 24,
        height: 24,
    },
    groupParent: {
        top: 0,
        width: 295,
    },
    statusOfCollateral: {
        alignSelf: 'stretch',
    },
    groupContainer: {
        top: 56,
        width: 296,
    },
    vectorParent: {
        height: 116,
        marginTop: 8,
        alignSelf: 'stretch',
    },
    frameContainer: {
        borderRadius: Border.br_xs,
        justifyContent: 'center',
    },
    frameParent: {
        backgroundColor: 'white',
        paddingTop: 8,
        marginTop: 16,
        paddingHorizontal: 16
    },
    circle: {
        width: 24,
        height: 24,
        borderRadius: 24 / 2,
        backgroundColor: '#98A2B3',
        justifyContent: 'center',
        alignItems: 'center',
    },
    insideContainer: {
        borderRadius: 16,
        borderWidth: 1,
        borderColor: "#E4E7EC",
        elevation: 20,
        paddingVertical: 16,
        paddingHorizontal: 20,
        marginTop: 16,
        shadowColor: "#98A2B3",
        backgroundColor: 'white',
        shadowOffset: {
            width: 0,
            height: Platform.OS === "ios" ? 2 : 6,
        },
        shadowRadius: 20,
        shadowOpacity: Platform.OS !== "android" ? 0.2 : 1,
    },
    bottomContainer: {
        position: 'absolute',
        bottom: 0,
        padding: 16,
        width: '100%',
        alignSelf: 'center',
        alignContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        borderColor: '#F1F3F5',
        borderTopWidth: 1,
        backgroundColor: 'white',
        ...Platform.OS === "web" && {
            paddingHorizontal: -16,
        }
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
});
export default KycCard;
